import '../App.css';
import {GoogleLogin} from '@react-oauth/google';
import Credentials from '../Credentials';
import React from "react";
import globals from '../Globals'
import requests from './Requests'
import EventBus from "../EventBus";

const LoginPhase = {
    Prompt: 0,
    Checking: 1,
    Done: 2,
    Error: 3
};

export default class LoginPage extends React.Component {
    // Var
    state = {
        phase: LoginPhase.Prompt,
        loginError: ""
    }

    // Callbacks
    onLoginSuccess = (response) => {
        this.setState({phase: LoginPhase.Checking});

        // Validate with server
        requests.login(response.credential).then(result => {
            if (result === true) {
                // Go to next page
                this.setState({phase: LoginPhase.Done});
                EventBus.emit("login");
            } else {
                // Show error page
                this.setState({phase: LoginPhase.Error, loginError: result});
            }
        });
    };

    onLoginFail = () => {
        this.setState({phase: LoginPhase.Error, loginError: "Google Login Failed"});
    };

    // Local-only bypass; the backend accepts "debug:<email>" only in Development
    onDebugLogin = () => {
        const email = Credentials.debugEmail;
        this.onLoginSuccess({ credential: `debug:${email}` });
    };

    retryLogin = () => {
        this.setState({phase: LoginPhase.Prompt});
    }

    // Methods
    createPage(inner) {
        return (
            <div align="center">
                <br/>
                <h2>Aurecas Admin</h2>
                <br/>
                {inner}
            </div>
        );
    }

    render() {
        let inner;

        switch (this.state.phase) {
            case LoginPhase.Prompt:
                inner = (
                    <>
                        <GoogleLogin onSuccess={this.onLoginSuccess} onError={this.onLoginFail}/>
                        {process.env.NODE_ENV === 'development' && (
                            <button style={{ marginTop: 16 }} onClick={this.onDebugLogin}>Debug Login</button>
                        )}
                    </>
                );
                break;
            case LoginPhase.Checking:
                inner = (
                    <>
                        <h3>Google Login OK</h3>
                        <h4>Connecting to Aurecas...</h4>
                    </>
                );
                break;
            case LoginPhase.Done:
                inner = (
                    <>
                        <h3>Login Successful</h3>
                    </>
                );
                break;
            case LoginPhase.Error:
                inner = (
                    <>
                        <h3>Login Failed</h3>
                        <h4>{this.state.loginError}</h4>
                        <button onClick={this.retryLogin}>Retry</button>
                    </>
                );
                break;
            default:
                inner = (
                    <>
                        <h1>LoginPage Unknown state: {this.state.phase}</h1>
                    </>
                );
                break;
        }

        return this.createPage(inner);
    }

    constructor(props) {
        super(props);

        // Check if there's a valid login stored
        let loginStr = localStorage.getItem("login");
        if (loginStr == null || loginStr === "") return;

        let login = JSON.parse(loginStr);
        globals.loginData = login;

        // Valid token? Go to next page
        if (new Date(login.tokenExpireDate).getTime() > Date.now()) {
            requests.importKeys().then(() => {
                this.state.phase = LoginPhase.Done;
                EventBus.emit("login");
            });
        }
    }
}